import { render, staticRenderFns } from "./AIAskCom.vue?vue&type=template&id=7973bb09&"
import script from "./AIAskCom.vue?vue&type=script&lang=ts&"
export * from "./AIAskCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports